import PropTypes from 'prop-types';
import React from 'react';

function DropDownSubGroup ({ children }) {
    return (
        <ul role="menu" className="nav-list__dropdown-sub list-unstyled no-margin clearfix">
            { children }
        </ul>
    );
}

DropDownSubGroup.propTypes = {
    children: PropTypes.node.isRequired
};

export default DropDownSubGroup;

